export default __webpack_public_path__ + "static/media/family.cbd8dc2e.svg";